import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  const scrollToRegister = () => {
    const element = document.getElementById("register");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url(https://static.readdy.ai/image/2ea0b8c267a34173059ce081fb680942/e0e87c9c8e6deec674f544c923a4968f.jpeg)"
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          {t("hero_title")}
        </h1>
        <p className="text-xl sm:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed">
          {t("hero_subtitle")}
        </p>
        <button
          onClick={scrollToRegister}
          className="bg-teal-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          {t("hero_cta")}
        </button>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
}
